import { ContactCenterContent, ContactFormContent, DisclaimerContent, HeaderContent } from "@interfaces/contactForm.interface";
import { Mockup } from "@interfaces/mockup.interface";

export const CONTACT_FORM_RESPONSE: Mockup = {
    success: [{
        response: {
            data: {
                titulo_formulario: 'Quiero que me llamen',
                descripcion_formulario: 'Para que un ejecutivo pueda contactarte debes completar con tus datos personales el siguiente formulario.',
                alt_image: 'Traspaso AFP PlanVital',
                texto_boton_volver: 'Volver',
                texto_boton_enviar: 'Enviar solicitud',
                texto_sitio_seguro: '<p>Este sitio es seguro. Conoce nuestras <a title=\\"Politicas AFP PlanVital\\" href=\\"https://www.planvital.cl/corporacion/politicas-y-estatutos/politicas-afp\\" target=\\"_blank\\" rel=\\"noopener\\">pol&iacute;ticas de seguridad y privacidad del sitio Web</a></p>',
                imagen: {
                    filename_disk: '76b3fcd5-88d1-408f-b4a0-ae2596c46de8.svg'
                }
            }
        }
    }],
    failures: []
};

export const CONTACT_CENTER_RESPONSE: Mockup = {
    success: [{
        response: {
            data: {
                texto_contact_center: 'Contact Center',
                numero_contact_center: '800 072 072'
            }
        }
    }],
    failures: []
};

export const HEADER_RESPONSE: Mockup = {
    success: [{
        response: {
            data: {
                titulo_banner_l1: 'Únete a AFP PlanVital',
                titulo_banner_l2: 'y mejora tu pensión',
            }
        }
    }],
    failures: []

};

export const DISCLAIMER_RESPONSE: Mockup = {
    success: [{
        response: {
            data: {
                titulo_disclaimer: 'Sobre la rentabilidad de los fondos de pensiones',
                disclaimer: '<p>La rentabilidad es variable, por lo que nada garantiza que las rentabilidades pasadas se repitan en el futuro. Inf&oacute;rmese sobre la rentabilidad de su Fondo de Pensiones, las comisiones y la calidad de servicio de las AFP en el sitio web de la Superintendencia de Pensiones.</p>\n<p><a title=\\"Superintendencia de Pensiones\\" href=\\"https://www.spensiones.cl\\" target=\\"_blank\\" rel=\\"noopener\\">https://www.spensiones.cl</a></p>',
            }
        }
    }],
    failures: []
};

export const DISCLAIMER_CONTENT: DisclaimerContent = {
    disclaimerTitle: 'Sobre la rentabilidad de los fondos de pensiones',
    disclaimerText: '<p>La rentabilidad es variable, por lo que nada garantiza que las rentabilidades pasadas se repitan en el futuro. Inf&oacute;rmese sobre la rentabilidad de su Fondo de Pensiones, las comisiones y la calidad de servicio de las AFP en el sitio web de la Superintendencia de Pensiones.</p>\n<p><a title=\\"Superintendencia de Pensiones\\" href=\\"https://www.spensiones.cl\\" target=\\"_blank\\" rel=\\"noopener\\">https://www.spensiones.cl</a></p>',
};

export const CONTACT_FORM_CONTENT: ContactFormContent = {
    formTitle: 'Quiero que me llamen',
    formDescription: 'Para que un ejecutivo pueda contactarte debes completar con tus datos personales el siguiente formulario.',
    altImage: 'Traspaso AFP PlanVital',
    backButtonText: 'Volver',
    sendButtonText: 'Enviar solicitud',
    safeSiteText: '<p>Este sitio es seguro. Conoce nuestras <a title=\\"Politicas AFP PlanVital\\" href=\\"https://www.planvital.cl/corporacion/politicas-y-estatutos/politicas-afp\\" target=\\"_blank\\" rel=\\"noopener\\">pol&iacute;ticas de seguridad y privacidad del sitio Web</a></p>',
    image: 'https://cms-qa.planvital.cl/assets/76b3fcd5-88d1-408f-b4a0-ae2596c46de8.svg'
};

export const HEADER_CONTENT: HeaderContent = {
    firstLine: 'Únete a AFP PlanVital',
    secondLine: 'y mejora tu pensión'
};

export const CONTACT_CENTER_CONTENT: ContactCenterContent = {
    contactTitle: 'Contact Center',
    contactNumber: '800 072 072'
};
